import React, { useEffect } from "react";
import config from "../config";

const Signup = () => {
  useEffect(() => {
    if (config?.signUpUrl) {
      // ✅ Same-tab redirect (no popup blockers)
      window.location.assign(config.signUpUrl);
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white flex-col text-center px-6">
      <h1 className="text-3xl font-bold text-gray-800">
        Redirecting you to the Signup Page...
      </h1>
      <p className="text-gray-600 mt-4">
        If you are not redirected automatically,
        <br />
        <a
          href={config.signUpUrl}
          className="text-orange-600 font-semibold underline hover:text-orange-700 transition"
        >
          Click here to Get Started Free
        </a>
      </p>
    </div>
  );
};

export default Signup;